export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9660.e968bfa0.jpg";